import './Loader.css'

function Loader() {
    return <span className="loader"></span>
}

export {Loader};